import * as React from "react"
const FramingFront = (props) => (
  <svg
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={406.886}
    height={250.987}
  >
    <g transform="translate(-2710.812 -2986.176)">
      <rect
        width={405}
        height={249.101}
        x={2711.755}
        y={2987.119}
        fill={props.iconColor}
        fillOpacity={0.2}
        stroke={props.iconColor}
        strokeWidth={2}
        rx={9}
      />
      <path
        stroke={props.iconColor}
        strokeWidth={2}
        d="M2821.554 3145.806h.01c3.856 1.715 7.095 4.36 9.353 7.636 2.26 3.275 3.447 7.048 3.434 10.894v6.3c0 1.007-.01 2.152-.757 3.391-.747 1.237-2.31 2.691-5.711 4.08-6.852 2.799-20.787 5.18-49.019 5.18-28.231 0-42.166-2.381-49.018-5.182-3.4-1.39-4.964-2.845-5.71-4.083-.75-1.24-.759-2.387-.759-3.397v-6.692c0-3.724 1.115-7.38 3.238-10.585 2.12-3.199 5.165-5.83 8.816-7.615l21.27-9.39.566-.25v-3.014l-.517-.26c-4.56-2.304-8.566-5.39-11.789-9.08-3.223-3.69-5.6-7.912-6.996-12.424l-.118-.382-.386-.182c-2.55-1.205-4.682-3.01-6.167-5.216-1.484-2.207-2.265-4.734-2.26-7.308v-5.059c0-2.135.546-4.241 1.587-6.164 1.04-1.922 2.554-3.61 4.429-4.939l.322-.227.056-.369a51.009 51.009 0 0 1 3.893-13.166c.774-1.705 1.442-2.995 2-4.073.033-.067.068-.133.101-.198l.061-.117c.71-1.366 1.173-2.259 1.238-3.427.062-1.101-.234-2.436-.741-4.729l-.04-.183a72.237 72.237 0 0 1-1.117-6.43 4.692 4.692 0 0 1 .755-3.202c.637-.968 1.613-1.725 2.782-2.153a6.42 6.42 0 0 1 3.684-.21c1.221.292 2.298.933 3.068 1.821l.015.017.016.017a23.605 23.605 0 0 0 5.391 4.186h.01c5.615 3.142 12.243 4.505 18.822 3.874a51.215 51.215 0 0 1 3.502-.117c12.828 0 22.801 2.4 29.977 7.066 7.153 4.65 11.64 11.622 13.366 20.988l.066.357.315.22c1.9 1.321 3.437 3.012 4.495 4.942a12.942 12.942 0 0 1 1.62 6.196v5.055c0 2.573-.777 5.1-2.262 7.308-1.484 2.207-3.616 4.011-6.166 5.216l-.386.181-.118.383c-1.396 4.515-3.774 8.741-6.998 12.434-3.225 3.693-7.233 6.781-11.795 9.087l-.517.26v3.069l.553.253z"
        style={{
          fill: "none",
        }}
      />
      <path
        fill={props.iconColor}
        d="M2971.709 3058.142c.707 0 1.28-.322 1.28-.719 0-.396-.574-.718-1.28-.718zm-116.536 0h116.536v-1.437h-116.536zM3029.336 3058.142c.707 0 1.28-.322 1.28-.719 0-.396-.573-.718-1.28-.718zm-32.015 0h32.015v-1.437h-32.015z"
        style={{
          strokeWidth: 0.958991,
        }}
      />
      <g
        style={{
          fill: "none",
        }}
      >
        <path
          fill={props.iconColor}
          d="M311.93 160.657c.707 0 1.281-.362 1.281-.808 0-.445-.574-.807-1.28-.807zm-28.173 0h28.173v-1.615h-28.173zM261.987 160.657c.707 0 1.28-.362 1.28-.808 0-.445-.573-.807-1.28-.807zm-29.454 0h29.454v-1.615h-29.454zM209.482 160.657c.707 0 1.28-.362 1.28-.808 0-.445-.573-.807-1.28-.807zm-28.174 0h28.174v-1.615h-28.174zM167.222 160.657c.706 0 1.28-.362 1.28-.808 0-.445-.574-.807-1.28-.807zm-29.455 0h29.455v-1.615h-29.455z"
          style={{
            strokeWidth: 1.01673,
          }}
          transform="matrix(1 0 0 .88965 2717.406 2987.746)"
        />
      </g>
      <g
        style={{
          fill: "none",
        }}
      >
        <path
          fill={props.iconColor}
          d="M311.93 160.657c.707 0 1.281-.362 1.281-.808 0-.445-.574-.807-1.28-.807zm-28.173 0h28.173v-1.615h-28.173zM261.987 160.657c.707 0 1.28-.362 1.28-.808 0-.445-.573-.807-1.28-.807zm-29.454 0h29.454v-1.615h-29.454zM209.482 160.657c.707 0 1.28-.362 1.28-.808 0-.445-.573-.807-1.28-.807zm-28.174 0h28.174v-1.615h-28.174zM167.222 160.657c.706 0 1.28-.362 1.28-.808 0-.445-.574-.807-1.28-.807zm-29.455 0h29.455v-1.615h-29.455z"
          style={{
            strokeWidth: 1.01673,
          }}
          transform="matrix(1 0 0 .88965 2717.242 3014.54)"
        />
      </g>
      <path
        fill={props.iconColor}
        d="M3083.028 3136.221c.707 0 1.28-.321 1.28-.718 0-.396-.573-.718-1.28-.718zm-28.173 0h28.173v-1.436h-28.173zM3033.084 3136.221c.707 0 1.281-.321 1.281-.718 0-.396-.574-.718-1.28-.718zm-29.453 0h29.453v-1.436h-29.453zM2980.58 3136.221c.706 0 1.28-.321 1.28-.718 0-.396-.574-.718-1.28-.718zm-28.174 0h28.173v-1.436h-28.173zM2938.32 3136.221c.706 0 1.28-.321 1.28-.718 0-.396-.574-.718-1.28-.718zm-29.455 0h29.454v-1.436h-29.454z"
        style={{
          fill: "none",
          strokeWidth: 0.958991,
        }}
      />
      <path
        fill={props.iconColor}
        d="M3051.106 3082.558c.707 0 1.281-.321 1.281-.718 0-.396-.574-.718-1.28-.718zm-195.933 0h195.933v-1.436h-195.933zM3051.106 3106.975c.707 0 1.281-.322 1.281-.718 0-.396-.574-.718-1.28-.718zm-195.933 0h195.933v-1.436h-195.933z"
        style={{
          strokeWidth: 0.958991,
        }}
      />
    </g>
  </svg>
)
export default FramingFront
